/**
 * @flow
 * @relayHash d50c08ecf30b2acb67268617d053cfce
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BackorderStatus = "CLOSED" | "FULFILLED" | "OPEN" | "PARTIALLY_FULFILLED";
export type CloseBackorderInput = {|
  id: string
|};
export type CloseBackorderMutationVariables = {|
  input: CloseBackorderInput
|};
export type CloseBackorderMutationResponse = {|
  +closeBackorder: {|
    +backorderEdge: {|
      +node: {|
        +id: string,
        +backorderNumber: string,
        +status: BackorderStatus,
        +expectedDate: ?any,
        +notes: ?string,
        +order: {|
          +id: string,
          +orderNumber: string,
        |},
        +customer: {|
          +id: string,
          +name: string,
        |},
        +updatedAt: any,
        +createdAt: any,
      |}
    |}
  |}
|};
export type CloseBackorderMutation = {|
  variables: CloseBackorderMutationVariables,
  response: CloseBackorderMutationResponse,
|};
*/


/*
mutation CloseBackorderMutation(
  $input: CloseBackorderInput!
) {
  closeBackorder(input: $input) {
    backorderEdge {
      node {
        id
        backorderNumber
        status
        expectedDate
        notes
        order {
          id
          orderNumber
        }
        customer {
          id
          name
        }
        updatedAt
        createdAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CloseBackorderInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "closeBackorder",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CloseBackorderPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "backorderEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "BackorderEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Backorder",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "backorderNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "expectedDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "notes",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "order",
                "storageKey": null,
                "args": null,
                "concreteType": "Order",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "orderNumber",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "customer",
                "storageKey": null,
                "args": null,
                "concreteType": "Customer",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "updatedAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CloseBackorderMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CloseBackorderMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CloseBackorderMutation",
    "id": null,
    "text": "mutation CloseBackorderMutation(\n  $input: CloseBackorderInput!\n) {\n  closeBackorder(input: $input) {\n    backorderEdge {\n      node {\n        id\n        backorderNumber\n        status\n        expectedDate\n        notes\n        order {\n          id\n          orderNumber\n        }\n        customer {\n          id\n          name\n        }\n        updatedAt\n        createdAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9b01eec3db17fac734b72c6514513af5';
module.exports = node;
